var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "root-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "label-container"
    }
  }, [_c('span', {
    staticClass: "label-vertical-text"
  }, [_vm._v("\n      " + _vm._s(_vm.yAxisLabel) + "\n    ")])]), _c('div', {
    attrs: {
      "id": "label-container"
    }
  }, _vm._l(_vm.yAxisKeys, function (key) {
    return _c('div', {
      key: key.label
    }, [_c('div', {
      class: {
        currentLabel: _vm.currentLabel === key.label
      },
      attrs: {
        "id": "key-container"
      }
    }, [_vm._v("\n        " + _vm._s(key.label) + "\n      ")])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }